import api from '@/http/axios'

export function page(query) {
  return api({
    url: '/ydstrong/sjty/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return api({
    url: '/ydstrong/sjty/add',
    method: 'post',
    data: obj
  })
}



export function login(obj) {
  return api({
    url: '/ydstrong/sjty/login',
    method: 'post',
    data: obj
  })
}

export function updateObj(obj) {
  return api({
    url: '/ydstrong/sjty/update',
    method: 'post',
    data: obj
  })
}



export function uploadFile(obj) {
  debugger
  return api({
    url: '/ydstrong/sjty/uploadFile',
    method: 'post',
    data: obj
  })
}

export function getStatistics() {
  var query = {}
  return api({
    url: '/ydstrong/statistics/getStatistics',
    method: 'post',
    data: query
  })
}

export function getVideoList() {
  return api({
    url: '/ydstrong/sjty/getVideoList',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/ydstrong.js